<template>
  <div class="right-sidebar">
    <div class="sidebar-header" @click="openChatWindow" >
      <img src="@/assets/images/message.png" alt="Headset"/>
      <span>{{ $t('message') }}</span>
    </div>
    <el-divider />
    <div class="sidebar-footer">
      <img src="@/assets/images/english.png" alt="Language" />
      <span @click="switchLang">{{ $t('switchLanguage') }}</span>
    </div>
  </div>
</template>
<script setup>
import { useI18n } from 'vue-i18n';
import {inject} from "vue";

const { locale } = useI18n();

function switchLang() {
  locale.value = locale.value === 'zh' ? 'en' : 'zh';
}

// Inject the isChatWindowOpen state from parent component
const isChatWindowOpen = inject('isChatWindowOpen');

function openChatWindow() {
  if (isChatWindowOpen) {
    isChatWindowOpen.value = true; // 使用 .value 访问和修改 ref 的值
  }
}


</script>
<style scoped>
.right-sidebar {
  position: fixed;
  top: 50%;
  transform: translateY(-50%);
  right: 0;
  background-color: #185BF8; /* Red color */
  border-radius: 8px 0 0 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  width: 48px;
  height: 128px;
}

.sidebar-header,
.sidebar-footer {
  display: flex;
  flex-direction: column; /* 改为垂直排列 */
  align-items: center;
  justify-content: center;
  margin-top: 10px;
}


.sidebar-header img,
.sidebar-footer img {
  width: 22px;
  height: 22px;
  margin-bottom: 4px; /* 添加一些间距 */
}

.sidebar-header span,
.sidebar-footer span {
  font-size: 8px;
  color: white;
  text-align: center;
}
.el-divider{
  height: 1px;
  width: 30px;
  margin: 10px;
  padding: 0;
}
</style>